export default __webpack_public_path__ + "static/media/welcome-footer-bg.d8e8454b.jpg";